// As funções de autenticação foram movidas para o pacote compartilhado
// @mediardex/api-client (consumido também pelo apps/mobile). Este arquivo apenas
// injeta o transporte do web (apiRequest) e o User-Agent, e instancia a API com
// o `User` rico do web — preservando os mesmos imports já usados nas páginas.
import { createAuthApi } from '@mediardex/api-client'
import { apiRequest } from '../request'
import { User } from '@/lib/api/common/interfaces/user.interface'

const authApi = createAuthApi<User>(apiRequest, {
    userAgent: () => navigator.userAgent,
})

export const login = authApi.login
// Portal do cliente: `auth/login` bloqueia CLIENT (é a porta do painel);
// `auth/app/login` aceita, e a autorização fica com a role de CLIENT.
export const appLogin = authApi.appLogin
export const registerClient = authApi.registerClient
export const verifyClientOtp = authApi.verifyClientOtp
export const resendClientOtp = authApi.resendClientOtp
export const refreshAuthToken = authApi.refreshAuthToken
export const registerPF = authApi.registerPF
export const registerPJ = authApi.registerPJ
export const registerMediator = authApi.registerMediator
export const forgotPassword = authApi.forgotPassword
export const resetPassword = authApi.resetPassword
export const resendVerificationEmail = authApi.resendVerificationEmail
export const resolveRegistrationLink = authApi.resolveRegistrationLink
export const validatePasswordSetup = authApi.validatePasswordSetup
export const setupPassword = authApi.setupPassword

// Tipos que viviam neste arquivo, reexportados do pacote para não quebrar
// eventuais imports externos.
export type {
    ValidatePasswordSetupResponse,
    ResolveRegistrationLinkResponse,
} from '@mediardex/api-client'
